import UAParser from "ua-parser-js";
import './main-collection-product-grid.scss';

( function (window) {
  if (!document.querySelector('[data-collection-load-more]')) return;

  const updateSwatchesEvent = new CustomEvent('swatchesUpdate:needed');

  var parser = new UAParser();

  var CONFIG = {
    bkpMobile: 768,
    bkpTablet: 1023,
    clientSpecs: parser.getResult()
  }

  var selectors = {
    header: '.site-header'
  }

  var ajaxinateSelectors = {
    products: '.card-grid__item',
    container: '[js-ajaxinate="container"]',
    loadMorePagination: '[data-load-more-pagination]',
    loadMoreCurrentCount: '[data-lm-label-current]',
    firstOfPageAttr: 'data-first-of-page',
    firstOfPage: '[data-first-of-page]'
  };

  var notEligibleForBFCache = function() {
    if(CONFIG.clientSpecs && CONFIG.clientSpecs.browser.name.indexOf('Safari') === -1) {
      console.log('NOT ELIGIBLE FOR BF CACHE!');
      return true;
    }
  }

  var onReady = function (fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  var on = function (eventName, {
    wrapperSelector,
    subjectSelector
  }, callback) {
    var wEls = document.querySelectorAll(wrapperSelector);
    if (!(wEls && wEls.length)) return console.warn('No wrapper found for "' + eventName + '" delegate event listener');

    var wrapperEls = Array.prototype.slice.call(wEls);

    if (!wrapperEls || !wrapperEls.length) return console.warn('Could not convert nodelist of wrappers into array on "' + eventName + '" delegate event listener');

    wrapperEls.map(function (el) {
      el.addEventListener(eventName, (event) => {
        if (event.target.closest(subjectSelector)) {
          callback.call(event.target, event);
        }
      });
    });
  };

  var getPageFromUrl = function (url) {
    if (!url) url = window.location.href;

    var page = 1;
    if (url.indexOf('page=') !== -1) {
      page = parseInt(url.split('page=')[1].split('&')[0])
    }

    return page;
  };

  var getUrlArgs = function (url) {
    if (!url) url = window.location.href;

    var args = '';
    url = url.split('?');
    if (url.length === 2) {
      url[1].split('&').forEach(arg => {
        if (arg.split('=')[0] !== 'page') {
          args += arg + '&';
        }
      });
    }

    return args;
  };

  var outerHeight = function (el) {
    const style = getComputedStyle(el);

    return (
      el.getBoundingClientRect().height +
      parseFloat(style.marginTop) +
      parseFloat(style.marginBottom)
    );
  }

  var offset = function (el) {
    var box = el.getBoundingClientRect();
    var docElem = document.documentElement;
    return {
      top: box.top + window.scrollY - docElem.clientTop,
      left: box.left + window.scrollX - docElem.clientLeft
    };
  }

  var smoothScrollTo = function (scrollTarget) {
    var header = document.querySelector(selectors.header);
    if (!header) return console.warn('Could not find header element!');
    var headerHeight = outerHeight(header);

    if (!scrollTarget) return console.warn('Could not find scroll target in DOM! Aborting scroll...');

    var targetOffset = offset(scrollTarget);

    var itemTop = targetOffset.top - headerHeight;
    window.scrollTo({
      left: 0,
      top: itemTop,
      behavior: 'smooth'
    });
  };

  var addMouseEvents = function () {
    var productsCards = document.querySelectorAll(ajaxinateSelectors.products);
    if (!(productsCards && productsCards.length)) return console.warn('Ajaxinate initialization could not find products!');

    var events = ['touchstart', 'mousedown'];
    var containerSelector = ajaxinateSelectors.container;


    events.map(function (event) {
      on(event, {
        wrapperSelector: ajaxinateSelectors.container,
        subjectSelector: ajaxinateSelectors.products
      }, function (e) {
        var currentPage = window.endlessScroll.currentPage ? window.endlessScroll.currentPage : 1;
        localStorage.setItem('lastProduct', '#' + e.target.closest(ajaxinateSelectors.products).id);
        history.replaceState({}, 'page ' + currentPage, '?' + getUrlArgs() + 'page=' + currentPage);
      });
    });
  };

  var updatePagination = function() {
    window.dispatchEvent(updateSwatchesEvent);
    var loadMorePagination = document.querySelector(ajaxinateSelectors.loadMorePagination);
    if(loadMorePagination) {
      var loadMoreContainer = document.querySelector(ajaxinateSelectors.container);
      var loadMoreProducts = loadMoreContainer.querySelectorAll(ajaxinateSelectors.products);

      if(loadMoreProducts) {
        var currentItemsCount = loadMoreProducts.length;
        var loadMoreCurrentCount = loadMorePagination.querySelector(ajaxinateSelectors.loadMoreCurrentCount);
      }

      loadMoreCurrentCount.innerHTML = currentItemsCount;
    }
  }

  var ajaxinateCallback = function (requestURL) {
    if(notEligibleForBFCache()) {
      var requestedPageNum = getPageFromUrl(requestURL);
      window.endlessScroll.currentPage = requestedPageNum;

      history.replaceState({}, 'page ' + window.endlessScroll.currentPage, '?' + getUrlArgs() + 'page=' + window.endlessScroll.currentPage);
    }

    /* if(window.endlessScroll.currentPage != 1) {
      window.endlessScroll.destroy();
      initAjaxinate('scroll');
    } */

    //if(window.endlessScroll.method === 'click') {
    var itemID = localStorage.getItem('lastProduct');
    if (!itemID && notEligibleForBFCache()) {
      var scrollTarget = document.querySelector(ajaxinateSelectors.firstOfPage);
      if (scrollTarget) {
        if(window.innerWidth > CONFIG.bkpTablet) smoothScrollTo(scrollTarget);

        scrollTarget.removeAttribute(ajaxinateSelectors.firstOfPageAttr);
      }

      console.warn('Could not find saved item ID in localStorage! Scrolling gracefully to first element of new page or aborting scroll...');
    }
    //}

    updatePagination();
    // Trigger event on load ended!
    const event = new CustomEvent('Alessi:loadMoreEnd');
    document.dispatchEvent(event);

    if (typeof (window.endlessScroll.addMouseEvents) !== 'undefined' && notEligibleForBFCache()) addMouseEvents();
  }

  var initAjaxinate = function (method) {
    window.endlessScroll = new window.Ajaxinate({
      container: ajaxinateSelectors.container,
      products: ajaxinateSelectors.products,
      pagination: {
        generalSelector: '#AjaxinatePagination',
        previousSelector: '.ajaxinate-pagination.ajaxinate-previous',
        nextSelector: '.ajaxinate-pagination.ajaxinate-next'
      },
      method: method || 'click',
      offset: 1000,
      callback: ajaxinateCallback
    });

    var ajaxPageNumber = getPageFromUrl();
    window.endlessScroll.currentPage = ajaxPageNumber;

    if(notEligibleForBFCache()) addMouseEvents();
  }

  onReady(function () {
    initAjaxinate();
    updatePagination();

    if (('scrollRestoration' in history) && notEligibleForBFCache()) {
      history.scrollRestoration = 'manual';
    }

    if(notEligibleForBFCache()) {
      var itemID = localStorage.getItem('lastProduct');
      if (!itemID) {
        console.warn('Could not find saved item ID in localStorage! Scrolling gracefully to first element of new page or aborting scroll...');
      }
    }

    var firstScrollTarget = document.querySelector('[data-first-of-page]');
    if(firstScrollTarget) {
      firstScrollTarget.removeAttribute('data-first-of-page');
    }

    if(notEligibleForBFCache()) {
      if(itemID) var scrollTarget = document.querySelector(itemID);
      if (scrollTarget) smoothScrollTo(scrollTarget);
      localStorage.setItem('lastProduct', '');
    }
  });

  window.addEventListener('filteredResults:rendered', function () {
    var containerEl = document.querySelector('#MainContent');
      if (containerEl && window.innerWidth > 0) {
        smoothScrollTo(containerEl);
      }

    initAjaxinate();
    updatePagination();
  });
} )(window);
